import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@repo/ui/primitives/badge";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "@repo/ui/primitives/scroll-area";
import { prefetchNamespacesForPath } from "@/lib/i18n-route-namespaces.js";

function isUnmodifiedLeftClick(event) {
  return event.button === 0
    && !event.metaKey
    && !event.altKey
    && !event.ctrlKey
    && !event.shiftKey;
}

export function SidebarSearchResults({
  searchResults,
  onResultSelect,
}) {
  const { t } = useTranslation("sidebar");
  if (!searchResults || searchResults.length === 0) return null;

  return (
    <div className="absolute left-2 right-2 top-full z-[var(--ds-layer-transient)] mt-1 flex flex-col overflow-hidden rounded-[var(--ds-radius-surface)] border border-sidebar-border bg-popover text-popover-foreground shadow-[var(--shadow-popover)] transition-opacity duration-[var(--ds-motion-duration-fast)] motion-reduce:transition-none">
      <div className="flex shrink-0 items-center justify-between border-b border-border-subtle bg-popover px-4 py-2.5">
        <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
          {t("searchResultsTitle", { defaultValue: "Search Results" })}
        </div>
        <Badge variant="secondary" className="h-4 px-1.5 text-[10px]">
          {searchResults.length}
        </Badge>
      </div>

      <ScrollArea className="max-h-[min(18rem,calc(100svh-12rem))] w-full" type="hover" scrollHideDelay={600} orientation="vertical">
        <div className="p-2 space-y-0.5 min-w-0 overflow-x-hidden">
          {searchResults.map((page, index) => {
            const href = page.url && page.url !== "#" ? page.url : null;
            const className = "group flex w-full min-w-0 cursor-pointer items-start gap-2.5 rounded-[var(--ds-radius-control-compact)] px-2.5 py-2 text-left text-sm transition-colors duration-[var(--ds-motion-duration-fast)] hover:bg-accent hover:text-accent-foreground motion-reduce:transition-none";
            const body = (
              <>
                <div className="shrink-0 rounded-[var(--ds-radius-control-compact)] bg-accent p-1.5 text-accent-foreground transition-colors group-hover:bg-primary/10 group-hover:text-primary motion-reduce:transition-none">
                  <page.icon className="size-3.5 text-muted-foreground transition-colors group-hover:text-primary motion-reduce:transition-none" />
                </div>
                <span className={`flex-1 min-w-0 whitespace-normal break-words leading-tight font-medium text-xs ${page.type === "main" ? "text-sidebar-foreground" :
                  page.type === "sub" ? "text-sidebar-foreground/90" :
"text-sidebar-foreground/80"
                  }`}>
                  {page.title}
                </span>
              </>
            );

            if (!href) {
              return (
                <div key={`${page.url}-${page.title}-${index}`} className={className}>
                  {body}
                </div>
              );
            }

            return (
              <Link
                key={`${page.url}-${page.title}-${index}`}
                to={href}
                className={className}
                onMouseEnter={() => { void prefetchNamespacesForPath(href); }}
                onFocus={() => { void prefetchNamespacesForPath(href); }}
                onClick={(event) => {
                  if (!isUnmodifiedLeftClick(event)) return;
                  onResultSelect?.();
                }}
              >
                {body}
              </Link>
            );
          })}
        </div>
      </ScrollArea>
    </div>
  );
}
